export type UsageSource = 'direct' | 'dashboard' | 'export' | 'chart';

export interface IUsageContext {
  source: UsageSource;
}

export const dashboardUsage: IUsageContext = { source: 'dashboard' };

export function toUsageQuery(usage?: IUsageContext): Record<string, string> | undefined {
  return usage ? { source: usage.source } : undefined;
}
